export default __webpack_public_path__ + "static/media/test-audio.006bd74b.mp3";